import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import Index from '../pages/index'
import Layouts from '../layouts/index'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const App = props => {
    const routes = [
        {
            path: "/",
            exact: true,
            name: () => <div>home!</div>,
            component: () => <Index {...props} />
        },
        {
            path: "/users",
            exact: true,
            name: () => <div>bubblegum!</div>,
            component: () => <h2>Bubblegum</h2>
        },
        {
            path: "/shoelaces",
            exact: true,
            name: () => <div>shoelaces!</div>,
            component: () => <h2>Shoelaces</h2>
        }
    ];



    const children = <Switch>
        {routes.map((route, index) => (
            // Render more <Route>s with the same paths as
            // above, but different components this time.
            <Route
                key={index}
                path={route.path}
                exact={route.exact}
                children={route.component}
            />
        ))}
    </Switch>

    return <ConfigProvider locale={zhCN}>
        <Router>
            <Layouts {...props} children={children} />
        </Router>
    </ConfigProvider>
}

export default App